import React from "react";
import './Contact.css';
import { useScrollBlock } from "../UseScrollBlock";
import Modal from "react-modal";
import submitting from '../../../common/images/sera-dots.png';
import confirmation from '../../images/check-circle.svg';
import { getUserId } from "../../../utils/Utils";
import { API } from "aws-amplify";
import { createContact, createInvestor } from "../../../graphql/mutations";

var showingContact = false;
function Contact({checkQueryParam = false, isInvestor = false, showButton = false}) {
  const [showModal, setShowModal] = React.useState(false);
  const [blockScroll, allowScroll] = useScrollBlock();
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [isAccredited, setIsAccredited] = React.useState(false);
  const [errorFirstName, setErrorFirstName] = React.useState(false);
  const [errorLastName, setErrorLastName] = React.useState(false);
  const [errorEmail, setErrorEmail] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(false);

  const [showForm, setShowForm] = React.useState(true);
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const contactContainerRef = React.useRef();

  const reset = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setMessage('');
    setIsAccredited(false);
    setErrorFirstName('');
    setErrorLastName('');
    setErrorEmail('');
    setErrorMessage('');
    setIsSubmitting(false);
    setShowForm(true);
    setShowConfirmation(false);
  }
  
  React.useEffect(() => {
    if (showModal) {
      blockScroll();
    } else {
      allowScroll();
    }
  }, [showModal, blockScroll, allowScroll])

  const onContactClicked = React.useCallback(() => {
    reset();
    blockScroll();
    setShowModal(true);
  }, [blockScroll]);

  const getContactForm = () => {
    return (
      <div ref={contactContainerRef} className="contact-container">
        
        <div className='modal-close-btn'
            onClick={() => {
              allowScroll();
              setShowModal(false);
            }}
        />
          
        <p className='title'>Contact us</p>
        
        <div className='contact-form-container'>
          
          <form className={`${showForm ? 'show' : 'hide'}`} autoComplete="off">
            <div className='name-container'>
            <div className='field'>
              <div>
                <div className='field-label'>First name</div>
                <input id="firstName" type="text" name="firstName" placeholder="Enter first name" 
                  value={firstName} onChange={onFirstNameChange} onBlur={onFirstNameChange} />
                {errorFirstName && (
                  <div className="field-error">Please enter a valid first name</div>
                )}
              </div>
            </div>
            <div className='field'>
              <div>
                <div className='field-label'>Last name</div>
                <input id="lastName" type="text" name="lastName" placeholder="Enter last name"
                  value={lastName} onChange={onLastNameChange} onBlur={onLastNameChange} />
                {errorLastName && (
                  <div className="field-error">Please enter a valid last name</div>
                )}
              </div>   
            </div>  
            </div>       
            <div className='field'>
              <div>
                <div className='field-label'>Email</div>
                <input id="email" name="email" type="email" placeholder="Enter email" 
                  value={email} onChange={onEmailChange} onBlur={onEmailChange} />
                {errorEmail && (
                  <div className="field-error">Please enter a valid email</div>
                )}
              </div>
            </div>
            <div className='field'>
              <div>
                <div className='field-label'>Message</div>
                <textarea id="message" name="message" placeholder={`${isInvestor ? 'Tell us what interests you about Sera' : 'How can we help you?'}`} value={message} onChange={onMessageChange} onBlur={onMessageChange} />
                {errorMessage && (
                  <div className="field-error">Please enter a message</div>
                )}
              </div>
            </div>

            {isInvestor ? (
              <React.Fragment>
                
                <div className='checkbox-container'> 
                  <input type="checkbox" checked={isAccredited} onChange={onIsAccreditedChange} />
                  <div>Are you an accredited investor?</div>
                </div>
                
                {/*
                <label>
                  <input type="checkbox" checked={isAccredited} onChange={onIsAccreditedChange} />
                  <span>Are you an accredited investor?</span>
                </label>
                */}
                <p className='disclaimer investor'>Accredited investors have earned at least $200K gross income individually or $300K jointly in each of the last 2 years, or have a minimum net worth of $1M, individually or jointly, excluding your primary residence.<br/>We will never sell your personal information and will use it only to keep you updated about our launch.</p>
              </React.Fragment>
            ) : (
                <p className='disclaimer'>We will never sell your personal information and will use it only to respond to you.</p>
            )}
            
            <div>
              {submitError && (
                <div className="field-error submit">There were errors. Please try again.</div>
              )}
            </div>
            
            <div className='processing-button-container'>
              <button className={`main ${isSubmitting ? 'processing' : ''}`} disabled={isSubmitDisabled()} onClick={onSubmit} >
                Submit
              </button>
              <img src={submitting} className={`rotation ${isSubmitting ? 'show' : 'hide'}`} alt='' />
            </div>
          </form>
          
          <div className={`contact-confirmation ${showConfirmation ? 'show' : 'hide'}`}>
            <img src={confirmation} alt="" />
            <div className='message'>
              <div className='title'>Thanks for contacting us.</div>
              <div className='subtitle'>The Sera team will get back to you as soon as possible.</div>
            </div>
            {isInvestor ? (
              <button className='main investor' onClick={onSendAnotherMessage} >
                Send another message
              </button>

            ) : (
              <button className='main' onClick={() => closeModal()} >
                Okay
              </button>
            )}
          </div>
        
        </div>
      </div>

    )
  }

  const onFirstNameChange = (e) => {
    if (e.target.value.length)
      setErrorFirstName(false);
    else
      setErrorFirstName(true);
    setFirstName(e.target.value)
  }

  const onLastNameChange = (e) => {
    if (e.target.value.length)
      setErrorLastName(false);
    else
      setErrorLastName(true);
    setLastName(e.target.value)
  }

  const onEmailChange = (e) => {
    if (e.target.value.length && isEmailValid(e.target.value))
      setErrorEmail(false);
    else
      setErrorEmail(true);
    setEmail(e.target.value)
  }

  const isEmailValid = (email) => {
    if (String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )) {
        return true;
      }
      return false;
  };

  const onMessageChange = (e) => {
    if (e.target.value.length)
      setErrorMessage(false);
    else
      setErrorMessage(true);
    setMessage(e.target.value);
  }

  const onIsAccreditedChange = (e) => {
    setIsAccredited(!isAccredited);
  }

  const isSubmitDisabled = () => {
    return (firstName.length === 0 || lastName.length === 0 || !isEmailValid(email) || message.length === 0 || isSubmitting);
  }


  const closeModal = () => {
    allowScroll();
    setShowModal(false);
  }

  React.useEffect(() => {
    if (!checkQueryParam || showingContact) {
      return;
    }

    showingContact = true;
    const queryParams = new URLSearchParams(window.location.search);
    const action = queryParams.get('action');

    if (action === 'contact') {
      onContactClicked();
    }
  }, [checkQueryParam, onContactClicked])

  const onSubmit = async () => {
    setSubmitError(false);
    setIsSubmitting(true);
    let userId = await getUserId();

    if (isInvestor) {
      let investorDetails = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        message: message,
        isAccredited: isAccredited,
        userInvestorsId: userId,
      }
      try {
        await API.graphql({ 
          query: createInvestor, 
          variables: { input: investorDetails }
        });
      } catch (err) {
        console.error("Error Message: ", err);
        setIsSubmitting(false);
        setSubmitError(true);
        return;
      };
      window.scrollTo({
        top: window.scrollY - 300,
        left: 0,
        behavior: "smooth",
      });
    } else {
      let contactDetails = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        message: message,
        userContactsId: userId,
      }
      try {
        await API.graphql({ 
          query: createContact, 
          variables: { input: contactDetails }
        });
      } catch (err) {
        console.error("Error Message: ", err);
        setIsSubmitting(false);
        setSubmitError(true);
        return;
      };
    }

    setIsSubmitting(false);
    setShowForm(false);
    setTimeout(() => {
      setShowConfirmation(true);
    }, "800");
  }

  const onSendAnotherMessage = () => {
    setShowConfirmation(false);
    setTimeout(() => {
      reset();
      setShowForm(true);
    }, "1000");
  }

  return (
    <React.Fragment>
      {isInvestor ? (
        <div className='investor-container'>
          {getContactForm()}
        </div>
      ) : (
        <React.Fragment>
          {showButton ? (
            <div className='contact-button-container'>
              <button className='main' onClick={onContactClicked}>Contact us</button>
            </div>
          ) : (
            <div className='contact-link' onClick={onContactClicked}>Contact</div>
          )}
          <Modal
            isOpen={showModal}
            onRequestClose={closeModal}
            contentLabel="My dialog"
            className="contact"
            overlayClassName="modal-background"
            closeTimeoutMS={1000}
          >
            {getContactForm()}
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Contact;

